/* NOKUKO 2026-10-15, frame selector for framed Alpe prints (brief 2026-10-14, R1 fallback).
   When the customer changes size or edition and the frame they had chosen does not exist for the new
   combination, Shopify returns the page with no variant and Horizon shows "Unavailable". The server-rendered
   picker (snippets/nokuko-frame-picker.liquid) then marks "No frame" as selected and flags the fieldset with
   data-nokuko-fallback="true". This script completes the fallback: it fires one change event on that input,
   so Horizon's own variant picker fetches the real "No frame" variant for the chosen size and edition and the
   price, button and gallery follow. Without JavaScript the customer simply taps "No frame" themselves. */
(function () {
  if (!('MutationObserver' in window)) return;
  var busy = false;
  function settle(root) {
    if (busy) return;
    var fieldset = root.querySelector('.nokuko-frames[data-nokuko-fallback="true"]');
    if (!fieldset) return;
    var input = fieldset.querySelector('input[type="radio"]:checked');
    if (!input) return;
    busy = true;
    fieldset.removeAttribute('data-nokuko-fallback');
    input.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () { busy = false; }, 1500);
  }
  function watch(picker) {
    if (picker.dataset.nokukoFramesWatched === 'true') return;
    picker.dataset.nokukoFramesWatched = 'true';
    new MutationObserver(function () { settle(picker); }).observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-nokuko-fallback'] });
    settle(picker);
  }
  function init() { document.querySelectorAll('variant-picker').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
